import { initLabels as initCoreLabels } from "@parksandresorts/core";

class SiteConfigurationStore {
  constructor() {
    this.siteConfiguration = {
      siteLabels: [],
      enableMyPages: false,
    };
  }

  init(siteConfiguration, locale) {
    this.siteConfiguration = {
      siteLabels: siteConfiguration.siteLabels ? siteConfiguration.siteLabels.list : [],
      enableMyPages: siteConfiguration.enableMyPages,
    };

    const coreLabelOverride = siteConfiguration.coreLabels?.reduce(
      (acc, current) => Object.assign(acc, { [current.key]: current.value }),
      {}
    );
    const coreLabelOverrideWithLanguage = {
      [locale]: coreLabelOverride,
    };

    initCoreLabels(locale, coreLabelOverrideWithLanguage);
  }

  getLabel(key, fallback) {
    const label = this.siteConfiguration.siteLabels.find((item) => item.key === key);
    return label ? label.value : fallback;
  }
}

const helper = new SiteConfigurationStore();
export default helper;
